"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = Footer;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _IconButton = require("../button/iconButton/IconButton");

var _colors = require("../../theme/colors");

var _Facebook = require("../../icons/trademarks/Facebook");

var _Twitter = require("../../icons/trademarks/Twitter");

var _Linkedin = require("../../icons/trademarks/Linkedin");

var _Youtube = require("../../icons/trademarks/Youtube");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Copyright = function Copyright() {
  return /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2"
  }, 'Copyright © ', new Date().getFullYear(), ' ', /*#__PURE__*/_react["default"].createElement(_core.Link, {
    color: "inherit",
    href: "https://www.novozymes.com/"
  }, "Novozymes"));
};

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    footer: _defineProperty({
      backgroundColor: _colors.colors.bg3,
      color: _colors.colors.black,
      borderTop: "1px solid ".concat(_colors.colors.primaryGreen),
      height: '2.8125rem'
    }, theme.breakpoints.down('xs'), {
      height: '7.1875rem'
    }),
    container: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontSize: '0.75rem',
      padding: '0.75rem 3rem'
    }, theme.breakpoints.down('xs'), {
      display: 'block',
      padding: '1rem'
    }),
    links: _defineProperty({}, theme.breakpoints.down('xs'), {
      marginTop: '1rem'
    }),
    socialMediaLinks: _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'flex',
      alignItems: 'center',
      marginTop: '1rem',
      textDecoration: 'none',
      color: _colors.colors.black,
      fontWeight: 'bold'
    }),
    link: _defineProperty({
      margin: '0 0.5rem',
      textDecoration: 'none',
      color: _colors.colors.black
    }, theme.breakpoints.down('sm'), {
      margin: '0 1rem 0 0'
    }),
    footerIcons: {
      display: 'flex',
      alignItems: 'center',
      width: '10.25rem',
      justifyContent: 'flex-end'
    },
    footerIcon: {
      height: '0.625rem',
      width: '0.625rem'
    },
    iconLink: {
      textDecoration: 'none',
      marginLeft: '0.5rem'
    },
    copyright: {
      width: '10.25rem'
    }
  };
});

function Footer(props) {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: classes.footer
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.container
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.copyright
  }, /*#__PURE__*/_react["default"].createElement(Copyright, null)), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    className: classes.links
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.novozymes.com",
    className: classes.link,
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Home"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.novozymes.com/legal-notice",
    className: classes.link,
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Legal"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.novozymes.com/privacy",
    className: classes.link,
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Privacy"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.novozymes.com/about-us/contact-us",
    className: classes.link,
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Contact")), /*#__PURE__*/_react["default"].createElement(_core.Hidden, {
    xsDown: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: classes.footerIcons
  }, props.children ? props.children : null, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.facebook.com/Novozymes",
    className: classes.iconLink,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    width: "1rem",
    height: "1rem",
    color: "spaceGreyB"
  }, /*#__PURE__*/_react["default"].createElement(_Facebook.Facebook, null))), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://twitter.com/Novozymes",
    className: classes.iconLink,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    width: "1rem",
    height: "1rem",
    color: "spaceGreyB"
  }, /*#__PURE__*/_react["default"].createElement(_Twitter.Twitter, null))), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://dk.linkedin.com/company/novozymes",
    className: classes.iconLink,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    width: "1rem",
    height: "1rem",
    color: "spaceGreyB"
  }, /*#__PURE__*/_react["default"].createElement(_Linkedin.Linkedin, null))), /*#__PURE__*/_react["default"].createElement("a", {
    href: "http://www.novozymes.tv/",
    className: classes.iconLink,
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton.IconButton, {
    width: "1rem",
    height: "1rem",
    color: "spaceGreyB"
  }, /*#__PURE__*/_react["default"].createElement(_Youtube.Youtube, null))))), /*#__PURE__*/_react["default"].createElement(_core.Hidden, {
    smUp: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body2",
    className: classes.socialMediaLinks
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.facebook.com/Novozymes",
    rel: "noopener noreferrer",
    target: "_blank",
    className: classes.link
  }, "Facebook"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://twitter.com/Novozymes",
    rel: "noopener noreferrer",
    target: "_blank",
    className: classes.link
  }, "Twitter"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://dk.linkedin.com/company/novozymes",
    rel: "noopener noreferrer",
    target: "_blank",
    className: classes.link
  }, "Linkedin"), /*#__PURE__*/_react["default"].createElement("a", {
    href: "http://www.novozymes.tv/",
    rel: "noopener noreferrer",
    target: "_blank",
    className: classes.link
  }, "Youtube"), props.children ? props.children : null))));
}